import { S3Error, shouldRetryS3Upload, getS3RetryDelay } from './s3ErrorHandler'

type QueryFn<ParamsType, ReturnType> = (params: ParamsType) => Promise<ReturnType>

/**
 * Специальная версия retryApiRequest для S3 загрузок с обработкой ошибок S3
 */
export const retryS3Upload =
  <ParamsType, ReturnType>(queryFn: QueryFn<ParamsType, ReturnType>, maxRetries = 3) =>
    async (params: ParamsType): Promise<ReturnType> => {
      let lastError: Error | null = null

      for (let attempt = 0; attempt <= maxRetries; attempt++) {
        try {
          return await queryFn(params)
        } catch (error) {
          lastError = error as Error

          // Если это не S3Error или это последняя попытка, пробрасываем ошибку
          if (!(error instanceof S3Error) || attempt === maxRetries) {
            throw error
          }

          if (!shouldRetryS3Upload(error)) {
            throw error
          }

          const delay = getS3RetryDelay(attempt)

          await new Promise(resolve => setTimeout(resolve, delay))
        }
      }

      throw lastError ?? new Error('Unknown error during S3 upload retry')
    }
